// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gxHdI","badges":"styles_badges__K144R"};